/*
* Info button
*/

$.fn.InfoButton = function() {
  let self = this;

  return function() {
    self.addClass('info-btn--dynamic')
    let clone = self.clone().attr('class', '').addClass('info-btn info-btn--clone')
    let transfer_classes = ['w-100', 'info-btn--no-label']
    transfer_classes.forEach(function(transfer_class) {
      if (self.hasClass(transfer_class)) {
        clone.addClass(transfer_class);
      }
    });
    self.append(clone);
    return self;
  }();
}
